<template>
  <div>
    <el-dialog
      title="订单评价"
      :visible.sync="dialogEvaluate"
      :modal="false"
      width="600px"
      top="25vh"
      @close="close"
      v-loading="loading">
      <div>
        <el-form ref="form" :model="entity" label-width="80px">
          <el-form-item label="订单编号">
            <el-input :disabled="true" v-model="entity.orderNo"></el-input>
          </el-form-item>
          <el-form-item label="评价时间">
            <el-date-picker
              v-model="entity.evaluateTime"
              type="datetime"
              placeholder="选择评价时间"
              align="right"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="服务评价">
            <el-select v-model="entity.evaluate" placeholder="请选择服务评价">
              <el-option label="非常满意" value="1"></el-option>
              <el-option label="很满意" value="2"></el-option>
              <el-option label="还不错" value="3"></el-option>
              <el-option label="一般" value="4"></el-option>
              <el-option label="差" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="评价内容">
            <el-input type="textarea" v-model="entity.evaluateContent"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {employee, order} from '@/api'
import {today, yesterday} from '@/utils/constant'

export default {
  name: 'OrderAllEvaluate',
  props: {
    dialogEvaluate: {
      type: Boolean,
      default: false
    },
    entity: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      orgCode: this.$store.state.user.orgCode,
      dynamicTags: [],
      entities: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  methods: {
    async submit () {
      this.loading = true
      let {code} = await order.updateOrderFromBasic({
        orderFormId: this.entity.orderFormId,
        evaluateTime: this.entity.evaluateTime,
        evaluateContent: this.entity.evaluateContent,
        evaluate: this.entity.evaluate,
        evaluateFlag: true
      })
      this.loading = false
      this.close(true)
      if (code === 0) {
        this.$message({
          message: '评价成功！',
          type: 'success'
        })
      } else {
        this.$message('网络错误，请稍后重试！')
      }
    },
    close (flush) {
      this.entities = {}
      this.$emit('dialogEvaluate', false)
      if (flush) this.$emit('flush')
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-form {
    width: 70%
  }
  .el-input {
    width: 320px;
  }
  .el-date-editor {
    width: 320px !important;
  }
  .el-select {
    width: 320px;
  }
  .el-textarea {
    width: 320px;
  }
</style>
